export const colors = {
    LandingPage_Background: '#f8fafc',
    LandingPage_Description: '#334155',
    Button_Primary: '#2563eb',
    Button_Secondary: '#475569', 
    Header_Background: "#ffffff",
    Header_Content: '#0f172a',
    Black: '#0f172a',
    Header: '#0f172a',
    Header_Text: "#ffffff",
    Header_Text_back: "#0f172a",
    Table_Header: '#f8fafc',
    Action_Button_Back: '#2563eb',
    ALERT_BUTTON_GOTO_COLOR: "#3b82f6",
    ALERT_BUTTON_CLOSE_COLOR:  "#ef4444",
    HEADER: '#0f172a',
    BORDER_BACKGROUND: "#e2e8f0",
    CAR_BOX_EVEN:'#f8fafc',
    CAR_BOX_ODD:'#ffffff'
}